export enum ReportStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}
